module.exports = __webpack_public_path__ + "static/media/retailed.f8cfd70e.svg";